// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"488":"8225812d","687":"084f05a6","754":"96790236"}[chunkId] + ".js";
};